export default __webpack_public_path__ + "static/media/ic_weth_40.8dbce838.svg";